export default __webpack_public_path__ + "static/media/arrow.972c36d1.svg";